import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getCoinsListApi } from "store/actions";
import { toast } from "react-toastify";

export default function AddLeaderboardTransactions({
  show,
  handleClose,
  handleConfirm,
  loading,
  rowData,
}) {
  const dispatch = useDispatch();
  const { coinsList } = useSelector(({ Game }) => Game);

  // Fetch coins list
  useEffect(() => {
    dispatch(getCoinsListApi({}));
  }, [dispatch]);

  // Submit handler
  const handleSubmit = () => {
    if (!rowData?.prizeType) {
      toast.error("Prize type not found");
      return;
    }

    if (!coinsList || coinsList.length === 0) {
      toast.error("Coins list not loaded");
      return;
    }

    // 🔥 Match prizeType with coin symbol
    const selectedCoin = coinsList.find(
      (coin) => coin.symbol === rowData.prizeType,
    );

    if (!selectedCoin) {
      toast.error("Matching coin not found");
      console.error("No coin found for symbol:", rowData.prizeType);
      return;
    }

    // ✅ Final payload
    const payload = {
      coinName: selectedCoin.name,
      coinSymbol: selectedCoin.symbol,
      coinIcon: selectedCoin.icon || selectedCoin.iconUrl || selectedCoin.image,
    };

    handleConfirm(payload);
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      centered
      size="md"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {rowData?.isLeaderboardTransaction ? "View" : "Add"} Reward
          Transaction
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="row">
          <div className="col-sm-6 my-2">
            <label>Rank</label>
            <input className="form-control" disabled value={rowData?.rank} />
          </div>

          <div className="col-sm-6 my-2">
            <label>Week No</label>
            <input className="form-control" disabled value={rowData?.weekNo} />
          </div>

          <div className="col-sm-6 my-2">
            <label>Year</label>
            <input className="form-control" disabled value={rowData?.year} />
          </div>

          <div className="col-sm-6 my-2">
            <label>Number of Amount</label>
            <input className="form-control" disabled value={rowData?.prizes} />
          </div>

          <div className="col-sm-6 my-2">
            <label>Currency Type</label>
            <div
              className="d-flex align-items-center rounded-2 p-2"
              style={{ background: "#efefef", height: 50 }}
            >
              <img
                src={rowData?.prizeIcon}
                alt=""
                style={{ height: 30, width: 30 }}
                className="me-2"
              />
              {rowData?.prizeType}
            </div>
          </div>

          {!rowData?.isLeaderboardTransaction && (
            <div className="col-12 mt-4 text-end">
              <button
                className="btn btn-primary btn-lg"
                onClick={handleSubmit}
                disabled={loading}
              >
                Submit
              </button>
            </div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
}
